import { NodeListComponent } from "./../node/components/node-list/node-list.component";
import { ApplicationSummaryComponent } from "./../application/components/application-summary/application-summary.component";
import { RouteGuard } from "src/app/core/route-guards/route-guard.guard";
import { StorageDataTransferComponent } from "./../storage/components/storage-data-transfer/storage-data-transfer.component";
import { DeploymentSettingComopnent } from "./components/deployment-setting/deployment-setting.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { JobDetailsComponent } from "../job/components/job-details/job-details.component";
import { JobListComponent } from "../job/components/job-list/job-list.component";
import { DeploymentGraphsComponent } from "./components/deployment-graphs/deployment-graphs.component";
import { DeploymentListComponent } from "./components/deployment-list/deployment-list.component";
import { DeploymentMainPanelComponent } from "./components/deployment-main-panel/deployment-main-panel.component";
import { DeploymentSummary } from "./components/deployment-summary/deployment-summary.component";
import { UserDetailsComponent } from "../user/components/user-details/user-details.component";
import { NodeDetailsComponent } from "../node/components/node-details/node-details.component";
import { ApplicationDetailsComponent } from "../application/components/application-details/application-details.component";
import { UserListComponent } from "../user/components/user-list/user-list.component";
import { UserAccessControlComponent } from "../user/components/user-access-control/user-access-control.component";
import { UserRoleNames } from "src/app/core/models/users";
import { NodeNetworkComponent } from "../node/components/node-network/node-network.component";
import { NodeGpuComponent } from "../node/components/node-gpu/node-gpu.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ReportsMainPanelComponent } from "./components/reports-main-panel/reports-main-panel.component";
import { ReportsDeploymentListComponent } from "./components/reports-deployment-list/reports-deployment-list.component";
import { NewDeploymentComponent } from "./modals/new-deployment/new-deployment.component";
import { ActionLogsComponent } from "../shared/components/actionlogs-component/action-logs.component";
import { HomeComponent } from "./components/home/home.component";

const routes: Routes = [
  // {
  //   path: "Analytics",
  //   children: [
  //     {
  //       path: "",
  //       component: DashboardComponent,
  //       canActivate: [RouteGuard],
  //       data: {
  //         role: [
  //           UserRoleNames.GlobalAdmin,
  //           UserRoleNames.PowerUser,
  //           UserRoleNames.DeploymentAdmin,
  //         ],
  //       }
  //     }
  //   ]
  // },
  {
    path: "Deployments List",
    children: [
      {
        path: "",
        component: DeploymentListComponent,
        canActivate: [RouteGuard],
        data: {
          role: [
            UserRoleNames.GlobalAdmin,
            UserRoleNames.PowerUser,
            UserRoleNames.DeploymentAdmin,
          ],
        },
      },
      {
        path: "new",
        component: NewDeploymentComponent,
        canActivate: [RouteGuard],
        data: {
          role: [UserRoleNames.GlobalAdmin],
        },
      },
    ],
    },
    {
        path: "Home",
        children: [
            { path: "summary", component: DeploymentSummary },
            {
                path: "",
                component: HomeComponent,
                canActivate: [RouteGuard],
                data: {
                    role: [
                        UserRoleNames.GlobalAdmin,
                        UserRoleNames.PowerUser,
                        UserRoleNames.DeploymentAdmin,
                    ],
                },
            },
            {
                path: "new",
                component: NewDeploymentComponent,
                canActivate: [RouteGuard],
                data: {
                    role: [UserRoleNames.GlobalAdmin],
                },
            },
        ],
    },
  // {
  //   path: "Dashboard",
  //   component: DashboardComponent,
  //   canActivate: [RouteGuard],
  //   data: {
  //     role: [
  //       UserRoleNames.GlobalAdmin,
  //       UserRoleNames.PowerUser,
  //       UserRoleNames.DeploymentAdmin,
  //     ],
  //   },
  // },
  // {
  //   path: "Reports/:deploymentName",
  //   component: ReportsMainPanelComponent,
  //   canActivate: [RouteGuard],
  //   data: {
  //     role: [
  //       UserRoleNames.GlobalAdmin,
  //       UserRoleNames.PowerUser,
  //       UserRoleNames.DeploymentAdmin,
  //     ],
  //   },
  //   children: [
  //     {
  //       path: "",
  //       component: ReportsDeploymentListComponent,
  //     },
  //   ],
  // },
  {
    path: "Reports/:deploymentName/AllReports",
    component: ReportsMainPanelComponent,
    canActivate: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
      ],
    },
    children: [
      {
        path: "",
        component: ReportsDeploymentListComponent,
      },
    ],
  },
  {
    path: "Reports/:cloudType/:deploymentName",
    component: ReportsMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
      ],
    },
    children: [
      {
        path: "reports",
        component: DeploymentGraphsComponent,
      },
    ],
  },
  {
    path: "Home/:cloudType/:deploymentName",
    component: DeploymentMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
      ],
    },
    children: [
      { path: "summary", component: DeploymentSummary },
      {
        path: "nodes",
        component: NodeListComponent,
        children: [
          { path: ":nodeName/Details", component: NodeDetailsComponent },
          { path: ":nodeName/Network", component: NodeNetworkComponent },
          { path: ":nodeName/GPU", component: NodeGpuComponent },
        ],
      },
      {
        path: "applications",
        component: ApplicationSummaryComponent,
        children: [
          {
            path: ":appName/:appVersion",
            component: ApplicationDetailsComponent,
          },
        ],
      },
      { path: "graphs", component: DeploymentGraphsComponent },
      { path: "settings", component: DeploymentSettingComopnent },
      { path: "Logs", component: ActionLogsComponent },
      { path: "storage", component: StorageDataTransferComponent },
      {
        path: "users",
        component: UserListComponent,
        children: [
          { path: ":userName", component: UserDetailsComponent },
          {
            path: ":userName/access-control",
            component: UserAccessControlComponent,
          },
        ],
      },
      {
        path: "jobs",
        component: JobListComponent,
        children: [
          { path: ":jobName/jobDetails", component: JobDetailsComponent },
          {
            path: ":jobName/storage/:storageName",
            component: StorageDataTransferComponent,
          },
        ],
      },
      { path: "", redirectTo: "summary", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class DeploymentRoutingModule {}
